import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { SourceBaseViewType } from "../api-generated";

type SourceDetailParams = {
  id: string;
  type: keyof typeof SourceBaseViewType;
};

export function useSourceIdParam() {
  const { id: idString } = useParams<SourceDetailParams>();
  const id = parseInt(idString!);

  //TODO: is this correct? should it not be in an effect?
  if (isNaN(id)) {
    throw new Error("Invalid source id");
  }

  //TODO: check here?
  return id;
}

export function useSourceUrlDetails(): {
  sourceId: number | undefined;
  //TODO: this will default pageNb to 1 - even if it's not a paginated source type
  //think about this pattern...
  pageNb: number | undefined;
  changePage: (newPageNb: number) => void;
} {
  const { id: idString } = useParams<SourceDetailParams>();
  const sourceId = parseInt(idString!);

  const [searchParams, setSearchParams] = useSearchParams();

  const pageNb: number | undefined = useMemo(() => {
    const defaultValue = undefined;

    const fromQueryString = searchParams.get("pageNb");
    if (fromQueryString === null) {
      return defaultValue;
    }

    try {
      return parseInt(fromQueryString);
    } catch {
      console.error(
        `Tried to parse ${fromQueryString} as a number but it ain't one`
      );
      return defaultValue;
    }
  }, [searchParams]);

  const changePage = (newPageNb: number) => {
    setSearchParams((prev) => ({ ...prev, pageNb: newPageNb.toString() }));
  };

  return {
    sourceId: sourceId === Number.NaN ? undefined : sourceId,
    pageNb,
    changePage,
  };
}
